/*
 * card-kind.js
 * Copyright (C) 2019 faircat <faircat@bogon>
 *
 * Distributed under terms of the MIT license.
 */
import request from '@/utils/request'

export function fetchCardKindList (query) {
  return request({
    url: '/card/api/card_kind/index',
    method: 'get',
    params: query
  })
}

export function fetchCardKind (id) {
  return request({
    url: '/card/api/card_kind/view',
    method: 'get',
    params: { id }
  })
}

export function createCardKind (data) {
  return request({
    url: '/card/api/card_kind/insert',
    method: 'post',
    data
  })
}

export function updateCardKind (data) {
  return request({
    url: '/card/api/card_kind/update',
    method: 'post',
    data
  })
}

export function deleteCardKind (id) {
  return request({
    url: '/card/api/card_kind/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/card-kind.js